import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import * as table from "./components/table";
import * as ground from "./components/ground";
import * as wall from "./components/wall";
import * as corner from "./components/corner";

const principle: Slide = {
  description:
    "The case of a source placed near a wall, which is a twisted situation, is here exemplified. Select the position of the source in the room and listen to the differences!",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "button",
          options: {},
          items: [{ name: "Table" }, { name: "Ground" }, { name: "Wall" }, { name: "Corner" }],
        },
      ],
      extraContent: [table.extraContent, ground.extraContent, wall.extraContent, corner.extraContent],
      components: [table.component, ground.component, wall.component, corner.component],
    },
  },
};

export default principle;
